import React from 'react';
import { useHistory } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import Table from '../Table';

const columns = [
	{
		name: 'returnNumber',
		label: 'Return Number',
		options: { filter: false, sort: false }
	},
	{
		name: 'returnDate',
		label: 'Return Date',
		options: { filter: false, sort: false }
	},
	{
		name: 'totalPrice',
		label: 'Total',
		options: { filter: false, sort: false }
	},
	{
		name: 'status',
		label: 'Status',
		options: { filter: false, sort: false }
	},
	{
		name: 'returnStatus',
		label: 'e-Return Status',
		options: { filter: false, sort: false }
	},
	{
		name: 'etaReturnStatus',
		label: 'ETA Return Status',
		options: { filter: false, sort: false }
	}
];

const tableOptions = { search: false, filter: false };

function InvoiceReturnsPanel({ record }) {
	const history = useHistory();
	return (
		<Grid container data-testid="invoice-returns-panel">
			<Grid item xs={12}>
				<Table
					model="invoicereturn"
					columns={columns}
					title="Invoice Returns"
					isChild={true}
					parentId={record.id}
					parentIdName="invoiceId"
					tableOptions={tableOptions}
					onRowClick={invoiceReturnId =>
						history.push(`/invoicereturn/${invoiceReturnId}`)
					}
				/>
			</Grid>
		</Grid>
	);
}

export default InvoiceReturnsPanel;
